import { httpRequest } from "../../http";

export type UpdateFolderPayload = {
  name: string;
};

export class CommandUpdateFolder {
  async run(
    organizationId: number,
    folderId: number,
    payload: UpdateFolderPayload,
  ) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/${organizationId}/folders/${folderId}/`;

    try {
      const response = await httpRequest<any>(url, {
        method: "PATCH",
        body: payload,
      });
      return response;
    } catch (error) {
      console.error("Error updating folder:", error);
      throw error;
    }
  }
}
